import { PlainButton, Tooltip } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";

export const ActionCell: FC = () => {
  const { t } = useTranslations();
  return (
    <div className="mx-auto flex h-full items-center justify-center">
      <Tooltip
        delay="default"
        placement="right"
        renderTrigger={({ props, ref }) => (
          <PlainButton
            className="flex h-6 w-8 items-center justify-center rounded-md transition"
            ref={ref}
            {...props}
          >
            <TrashIcon />
          </PlainButton>
        )}
      >
        {t({
          defaultMessage: "Delete",
          id: "common.delete",
        })}
      </Tooltip>
    </div>
  );
};
